import React from "react";
import PropTypes from "prop-types";
import "./Accordian.scss";
import { Collapse } from "antd";

const { Panel } = Collapse;

const Accordian = (props) => {
  const { children, header } = props;

  return (
    <Collapse
      className="accordian"
      bordered={false}
      expandIconPosition={"right"}
    // expandIcon={<img src="/img/accordian-icon.svg" />}
    >
      <Panel header={header}>{children}</Panel>
    </Collapse>
  );
};

Accordian.propTypes = {
  header: PropTypes.node,
};

Accordian.defaultProps = {
  header: null,
};

export default Accordian;
